const GetOwnerDetails = (fullFormState) => {
    if(fullFormState.pages.retrieveAccount.clientType === 'Prospect') {
        return null;
    }

    let ownerDetails;
    let policyOwnershipType = fullFormState.pages.retrieveAccount && fullFormState.pages.retrieveAccount.policyOwnership;
    let owner = fullFormState.pages.retrieveAccount.owner;
    let jointOwner = fullFormState.pages.retrieveAccount.jointOwner;
    let insured = fullFormState.pages.retrieveAccount.insured;
    if (policyOwnershipType === "joint") {
        if (insured !== "" && insured !== "Other") {
            ownerDetails = fullFormState.pages.retrieveAccount.clientData.owners.find(el => el.covrGeneratedID === insured);
        } else {
            ownerDetails = fullFormState.pages.retrieveAccount.clientData.owners.find(el => el.covrGeneratedID === jointOwner);
        }
    } else {
        ownerDetails = fullFormState.pages.retrieveAccount.clientData.owners.find(el => el.covrGeneratedID === owner) || fullFormState.pages.retrieveAccount.clientData.soleProprieter.find(el => el.covrGeneratedID === owner);
    }
    if (ownerDetails && Object.keys(ownerDetails).length !== 0) {
        return ownerDetails;
    }
    else {
        return null;
    }
}

export default GetOwnerDetails;


// WEBPACK FOOTER //
// ./src/components/Product/Common/GetOwnerDetails.js